import {Component, Input, OnInit} from '@angular/core';
import {StartupService} from "../../../service-ui/startup.service";
import {ServiceProvider} from "../../../../model/ServiceProvider";
import {Facility} from "../../../../model/Facility";
import {User} from "../../../../model/User";
import {UserService} from "../../../service-data/user.service";
import {ServerErrorToastService} from "../../../service-ui/server-error-toast.service";
import {LanguagePipe} from "../../../pipe/language.pipe";

@Component({
  selector: 'app-facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.css']
})
export class FacilityComponent implements OnInit {
  @Input() facility: Facility;

  userId: number;

  constructor(public startupService: StartupService, private userService: UserService,
              private serverErrorToastService: ServerErrorToastService) { }

  ngOnInit() {
  }

  // Granting or revoking a facility property is a Cognito-backed access change,
  // so it reports failure rather than logging it. See the note in
  // UserComponent - previously a failed revoke ran the success callback,
  // because the service's catchError returned an observable that emits.

  revokeProperty (userId: number, property: string) {
    this.userService.getUser('' + userId).subscribe(
      user => {
        this.userService.revokeProperty(user, property, '' + this.facility.ID).subscribe(
          user2 => {
            this.serverErrorToastService.reportSuccess(LanguagePipe.get('Privileges revoked', 'compressSpaces'));
          },
          error => {
            this.serverErrorToastService.reportError('revokeProperty', error,
              LanguagePipe.get('Could not revoke the privilege. The user still has it.', 'compressSpaces'));
          });
      },
      error => {
        this.serverErrorToastService.reportError('getUser', error,
          LanguagePipe.get('Could not load the user.', 'compressSpaces'));
      });
  }

  grantProperty (userId: number, property: string) {
    this.userService.getUser('' + userId).subscribe(
      user => {
        this.userService.grantProperty(user, property, '' + this.facility.ID).subscribe(
          user2 => {
            this.serverErrorToastService.reportSuccess(LanguagePipe.get('Privileges granted', 'compressSpaces'));
          },
          error => {
            this.serverErrorToastService.reportError('grantProperty', error,
              LanguagePipe.get('Could not grant the privilege. The user does not have it.', 'compressSpaces'));
          });
      },
      error => {
        this.serverErrorToastService.reportError('getUser', error,
          LanguagePipe.get('Could not load the user.', 'compressSpaces'));
      });
  }

}


